import {MenuItem, Select, Stack, TextField, Typography} from "@mui/material";
import {useState} from "react";
import Loading from "../../../components/Loading";
import useServiceQueries from "../../../hooks/queries/useServiceQueries";
import {hasFormChanged, zodSubmit} from "../../../utils/FormUtils";

import { z } from "zod";


export const schema = z.object({
    service: z
        .string({ required_error: "Szolgáltatás kiválasztása kötelező" })
        .nonempty("Szolgáltatás kiválasztása kötelező"),
    price: z
        .string({ required_error: "Az ár megadása kötelező" })
        .refine(val => !isNaN(Number(val)) && Number(val) > 0, {
            message: "Az árnak pozitív számnak kell lennie",
        }),
});

const PriceData = ({reference, data, prices, handleSubmit}) => {
    const {serviceBusinessQuery} = useServiceQueries()
    const {data: services, isPending: loading} = serviceBusinessQuery

    const usedServices = prices.map(p => p.service.id)
    const usableColleagues = services.filter(coll => !usedServices.includes(coll.id) || coll.id === data?.service.id)

    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    
    if (loading) return <Loading isLoading />

    return <form
        ref={reference}
        onSubmit={e => setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
    >
        <Stack spacing={1} marginTop={2} marginBottom={2}>
            <Typography variant='caption' color='primary.main'>
                Szolgáltatás*
            </Typography>
            <Select
                defaultValue={data?.service}
                error={!!errors?.service}
                helperText={errors?.service}
                name='service'
                variant='standard'
            >
                {usableColleagues?.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
            </Select>

            <Typography variant='caption' color='primary.main'>
                Ár*
            </Typography>
            <TextField
                defaultValue={data?.price}
                error={!!errors?.price}
                helperText={errors?.price}
                name='price'
                variant='standard'
            />
        </Stack>

    </form>
}

export default PriceData